export default __webpack_public_path__ + "static/media/m.ffb80770.mp4";